export default "__VITE_ASSET__d0a346c1__"